<template>
  <div id="app">
    <div class="view-wrapper">
      <router-view></router-view>
    </div>

    <b-navbar type="dark" variant="dark" fixed="bottom">
      <b-navbar-nav>
        <b-nav-item href="#/index" :active="activePage === 'index' || activePage === ''">
          <b-icon-lightning-charge-fill></b-icon-lightning-charge-fill>
          &nbsp;
          <span>背诵</span>
        </b-nav-item>
        <b-nav-item href="#/word-base" :active="activePage === 'word-base'">
          <b-icon-journal-bookmark-fill></b-icon-journal-bookmark-fill>
          &nbsp;
          <span>词库</span>
        </b-nav-item>
        <b-nav-item href="#/about" :active="activePage === 'about'">
          <b-icon-emoji-sunglasses-fill></b-icon-emoji-sunglasses-fill>
          &nbsp;
          <span>关于</span>
        </b-nav-item>
      </b-navbar-nav>
    </b-navbar>
  </div>
</template>

<script>
import VueRouter from 'vue-router'
import Index from '@/pages/Index.vue'
import WordBase from '@/pages/WordBase.vue'
import About from '@/pages/About.vue'


const routes = [
  { path: '/', component: Index },
  { path: '/index', component: Index },
  { path: '/word-base', component: WordBase },
  { path: '/about', component: About },
]

export default {
  name: 'App',
  
  router: new VueRouter({
    routes,
  }),

  data: () => ({
    activePage: '',
  }),

  watch: {
    $route(to) {
      this.activePage = to.path.slice(1)
    }
  },

  mounted() {
    this.activePage = this.$router.history.current.path.slice(1)
  },

  methods: {
    handleTabChange(val) {
      this.$router.push(`/${val}`)
    },
  },
}
</script>

<style scoped>
.navbar-nav {
  display: flex;
  width: 100%;
  justify-content: space-around;
}

.view-wrapper {
  padding-bottom: 80px;
}
</style>
